/**
 * @generated SignedSource<<3c37091dfdd0b8c8073210b5c1051468>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilters_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MapFilterList",
      "kind": "LinkedField",
      "name": "filterLists",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapFilterList_filterList"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "48a26df735fce1636c7c1b2e8cb56046";

module.exports = node;
